import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useHistory, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useReactToPrint } from "react-to-print";
import { MoonLoader } from "react-spinners";
import swal from "sweetalert";
import axios from "axios";

import { handleInputs } from "../../../utils/HandleInputs";
import { showToast } from "../../../utils/ToastHelper";
import { BASE_URL } from "../../Const/Url";
import * as path from "./../../Routes/RoutePaths";

import Loader from "../../CustomCommons/Loader";
import { can_add_invoice, has_permissions } from "../../CustomCommons/utils";
import Permission from "../../CustomCommons/Permission";
import Scanner2 from "./../Scanner2";
import PreviewCreate from "./../PreviewCreate";
import DoIcon from "../../CustomCommons/DoIcon";

import ProductDetails from "./ProductDetails";
import InvoiceDetails from "./InvoiceDetails";
import PaymentStatus from "./PaymentStatus";

import "./../invoice.css";

const VariantEditInvoice = () => {
  // State Hooks
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [customCharge, setCustomCharge] = useState(80);
  const [customPrice, setCustomPrice] = useState(0);
  const [deleted, setDeleted] = useState([]);
  const { id } = useParams();
  const [sInvoice, setSInvoice] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [Found, setFound] = useState(false);
  const [FoundCustomer, setFoundCustomer] = useState({});

  // Address related states
  const [selectedDivision, setSelectedDivision] = useState({
    label: "",
    value: "",
  });
  const [selectedDistrict, setSelectedDistrict] = useState({
    label: "",
    value: "",
  });
  const [selectedTown, setSelectedTown] = useState({ label: "", value: "" });
  const [selectLoading, setSelectLoading] = useState(false);
  const [districtList, setDistrictList] = useState([]);
  const [upazillaList, setUpazillaList] = useState([]);

  // Pathao related states
  const [deliveryService, setDeliveryService] = useState({
    label: "Pathao",
    value: 0,
  });
  const [pathaoCity, setPathaoCity] = useState({ label: "", value: "" });
  const [pathaoZone, setPathaoZone] = useState({ label: "", value: "" });
  const [pathaoArea, setPathaoArea] = useState({ label: "", value: "" });

  // Form and invoice data
  const { register, control, watch, reset, setValue } = useForm();

  // Move watchFields inside the component after useForm is initialized
  const watchFields = watch(["division", "district", "town", "zip"]);

  const [InvoiceAllData, setInvoiceAllData] = useState({});
  const [paymentAllData, setPaymentAllData] = useState({});
  const [fromCode, setFromCode] = useState("880");
  const [toCode, setToCode] = useState("880");
  const [mainState, setMainState] = useState({});
  const [exchanged, setExchanged] = useState([]);
  const [mainInnerState, setMainInnerState] = useState({});
  const [pS, setPs] = useState(0);
  const [Jdata, setJData] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [ProductsList, setProductsList] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [defaultValue, setdefaultValue] = useState([]);
  const [originalInvoiceProducts, setOriginalInvoiceProducts] = useState([]);

  // Status states
  const [invoice_status, setInvoiceStatus] = useState(0);
  const [Delivery_status, setDeliveryStatus] = useState(0);
  const [invoice_delivery_type, setInvoiceDeliveryType] = useState(0);
  const [invoice_payment_type, setInvoicePaymentType] = useState(0);
  const [invoice_delivery_charge, setInvoiceDeliveryCharge] = useState(2);
  const [invoice_discount_type, setInvoiceDiscountType] = useState(0);

  // Financial states
  const [paid, setPaid] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [exArray, setExarray] = useState([]);

  // Refs
  const print = useRef();
  const history = useHistory();

  // Constants
  const delivery_charge = useMemo(
    () => ({
      0: 80,
      1: 150,
    }),
    []
  );

  const invoice_choices = [
    { value: 0, label: "Recieved" },
    { value: 1, label: "Pending" },
    { value: 2, label: "Refunded" },
    { value: 3, label: "Exchanged" },
  ];

  const delivery_choices = [
    { value: 0, label: "Returned" },
    { value: 1, label: "Order Placed" },
    { value: 2, label: "Delivered" },
    { value: 3, label: "Pending" },
    { value: 4, label: "Hold" },
    { value: 5, label: "Dispatched" },
  ];

  const paymentType = [
    { value: 0, label: "Cash On Delivery" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank Transfer" },
    { value: 3, label: "Bkash" },
    { value: 4, label: "SSLECOMMERZ" },
    { value: 5, label: "Nagad" },
    { value: 6, label: "Kaaruj Delivery" },
  ];

  // Helper functions
  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const convertData = (date) => new Date(date).toISOString().substring(0, 10);

  // Memoized calculations
  const getSubTotal = useCallback(() => {
    const allarray = Object.values(mainState).map((curr) => {
      if (curr.variant && curr.variant.length > 0) {
        return parseInt(curr.variant[0].total) || 0;
      }
      return 0;
    });
    return allarray.reduce((a, b) => a + b, 0);
  }, [mainState]);

  const getFlatDiscount = useCallback(() => Discount, [Discount]);
  const getPercentageDiscount = useCallback(
    () => parseInt((Discount / 100) * getSubTotal()),
    [Discount, getSubTotal]
  );
  const getDeliveryCharge = useCallback(
    () =>
      invoice_delivery_charge === 2
        ? customCharge
        : delivery_charge[invoice_delivery_charge],
    [invoice_delivery_charge, customCharge, delivery_charge]
  );

  const getGrandTotal = useCallback(() => {
    const discountCalc =
      invoice_discount_type === 0 ? getFlatDiscount() : getPercentageDiscount();
    const charge = parseInt(getDeliveryCharge());
    const grand =
      getSubTotal() +
      Math.max(charge, 0) +
      (Number(customPrice) || 0) -
      discountCalc;
    return Math.max(0, parseInt(grand));
  }, [
    getSubTotal,
    getDeliveryCharge,
    invoice_discount_type,
    getFlatDiscount,
    getPercentageDiscount,
    customPrice,
  ]);

  const getDueAmount = useCallback(
    () => Math.max(0, getGrandTotal() - paid),
    [getGrandTotal, paid]
  );

  // Data transformation functions
  const transformData = (products) => {
    return products.reduce((result, product) => {
      const uniqueKey = `${product.product_name}_${product.variant_name}_${product.variant}`;
      const variantData = {
        label: product.variant_name,
        value: product.variant,
        price: product.variantObj.price,
        stock: product.variantObj.stock,
        quantity: product.quantity,
      };

      if (!result[uniqueKey]) {
        result[uniqueKey] = [];
      }

      result[uniqueKey].push(variantData);
      return result;
    }, {});
  };

  const formatInvoiceProducts = (products) => {
    const result = {};

    products.forEach((item) => {
      // Create unique key for each variant to handle multiple variants of same product
      const productSkuKey = item.sku;
      const variantSkuKey = item.variantObj?.sku;
      const uniqueKey =
        productSkuKey && variantSkuKey
          ? `${productSkuKey}_${item.variant_name}_${variantSkuKey}`
          : `${item.product_name}_${item.variant_name}`;

      if (!result[uniqueKey]) {
        result[uniqueKey] = {
          id: item.product,
          variant: [],
          variantObj: {},
          price: parseFloat(item.main_price) || 0, // Use main_price instead of total
          stock: item.variantObj.stock,
          thumb: item.thumb, // Use thumb directly without replacing _optimized
          discount: parseFloat(item.discount_value) || 0,
          productName: item.product_name, // Store original product name
          productSku: item.sku, // Store SKU
        };
      }

      const variant = {
        id: item.variant,
        name: item.variant_name,
        price: parseFloat(item.variantObj.price),
        stock: item.variantObj.stock,
        sku: item.variantObj?.sku || "",
        quantity: item.quantity.toString(),
        total: parseFloat(item.total),
      };

      // For edit-invoice preloaded items: if variant price is 0 but total and quantity exist,
      // derive variant price as per-unit total minus product base/discounted price.
      if (
        result[uniqueKey] &&
        (isNaN(variant.price) || parseFloat(variant.price) === 0) &&
        parseFloat(variant.total) > 0 &&
        parseFloat(item.quantity) >= 1
      ) {
        const productBase =
          (parseFloat(result[uniqueKey].discount) || 0) === 0
            ? parseFloat(result[uniqueKey].price) || 0
            : parseFloat(result[uniqueKey].discount) || 0;
        const perUnitTotal =
          parseFloat(variant.total) / parseFloat(item.quantity);
        const derivedVariantPrice = perUnitTotal - productBase;
        variant.price = derivedVariantPrice > 0 ? derivedVariantPrice : 0;
      }

      // Each entry has only one variant
      result[uniqueKey].variant = [variant];
      result[uniqueKey].variantObj[item.variant_name] = variant;
    });
    return result;
  };

  const getDeletedInvoiceProducts = useCallback(() => {
    if (!originalInvoiceProducts || originalInvoiceProducts.length === 0) {
      return [];
    }

    // Create a map of unique keys from original invoice products
    const originalKeysMap = new Map();
    originalInvoiceProducts.forEach((item) => {
      const productSkuKey = item.sku;
      const variantSkuKey = item.variantObj?.sku;
      const uniqueKey =
        productSkuKey && variantSkuKey
          ? `${productSkuKey}_${item.variant_name}_${variantSkuKey}`
          : `${item.product_name}_${item.variant_name}`;

      // Store the invoice product ID with the unique key
      if (!originalKeysMap.has(uniqueKey)) {
        originalKeysMap.set(uniqueKey, []);
      }
      originalKeysMap.get(uniqueKey).push(item.id);
    });

    // Get current mainState keys
    const currentKeys = new Set(Object.keys(mainState));

    // Find deleted variants (exist in original but not in current)
    const deletedIds = [];
    originalKeysMap.forEach((ids, uniqueKey) => {
      if (!currentKeys.has(uniqueKey)) {
        // This variant was deleted, add all its IDs
        deletedIds.push(...ids);
      }
    });

    if (deletedIds.length > 0) {
      console.log("Deleted variants:", deletedIds);
    }

    return deletedIds;
  }, [originalInvoiceProducts, mainState]);

  const formatInv = useCallback(
    (inputData) => {
      const formattedData = [];
      for (const key in inputData) {
        const product = inputData[key];
        product.variant?.forEach((variant) => {
          if (parseInt(variant.quantity) >= 0) {
            const existingInvoiceProductId = originalInvoiceProducts?.find(
              (item) =>
                item.product === product.id && item.variant === variant.id
            )?.id;
            formattedData.push({
              quantity: variant.quantity,
              total: variant.total.toString(),
              product_name: product.productName || key.split("_")[0], // Use stored product name
              variant_name: variant.name,
              is_custom: false,
              created_at: new Date(),
              invoice_date: InvoiceAllData.invoice_date,
              product: product.id,
              variant: variant.id,
              id: existingInvoiceProductId,
              is_regular: true,
            });
          }
        });
      }
      return formattedData;
    },
    [InvoiceAllData, originalInvoiceProducts]
  );

  // API calls
  const getProductList = useCallback(() => {
    if (inputQuery?.length > 1) {
      const url = inputQuery
        ? `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice_pagination/?query=${inputQuery}&limit=20`
        : `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice_pagination/`;

      axios
        .get(url)
        .then((res) => {
          const { results } = res.data.data;

          // Create variant-based options instead of product-based
          const variantOptions = [];
          results.forEach((product) => {
            product.variants.forEach((variant) => {
              variantOptions.push({
                label: `${product.name} [${product.sku ?? ""}] - ${
                  variant.name
                } [[${variant.sku}]]`,
                value: variant.id,
                price: variant.calculated_price,
                discount: 0,
                stock: variant.stock,
                product_id: product.id,
                product_name: product.name,
                product_sku: product.sku,
                variant_name: variant.name,
                variant_sku: variant.sku,
                thumb: product.thumb_url || product.thumb,
                main_price: 0,
                main_discount: 0,
                image: `${
                  product?.thumb_resized_url
                    ? product.thumb_resized_url
                    : `${BASE_URL}media/default/lazy_placeholder.jpg`
                }`,
              });
            });
          });

          setProductsList(variantOptions);
        })
        .catch((err) => console.error(err));
    }
  }, [inputQuery]);

  const getInvoice = useCallback(() => {
    console.log("getInvoicetest");

    axios
      .get(`${BASE_URL}api/v1/sales/inventory/invoice/${id}`)
      .then((res) => {
        if (res.data.status) {
          const data = res.data.data;
          setSInvoice(data);
          setExchanged(data.invoice_products);

          const invoiceData = {
            invoice_date: data.invoice_date,
            invoice_due_date: data.due_date,
            invoice_bill_from: data.bill_from,
            invoice_bill_to: data.bill_to,
            invoice_from_mobile: data.from_mobile?.replace("+880", ""),
            invoice_to_mobile: data.to_mobile?.replace("+880", ""),
            invoice_from_address: data.from_address,
            invoice_to_address: data.to_address,
            invoice_delivery_charge: data.delivery_charge_type,
            invoice_delivery_status: data.delivery_status,
            invoice_payment_status: data.payment_status,
            invoice_notes: data.notes,
            invoice_to_email: data?.to_email,
            invoice_from_email: data?.from_email,
            invoice_number: data?.number,
            invoice_barcode: data?.barcode_text,
            barcode: data?.barcode,
            invoice_to_address2: data.to_address2,
            to_zip_code: data.to_zip_code,
            to_country: data.to_country,
            to_district: data.to_district,
            to_division: data.to_division,
            to_city: data.to_city,
          };

          setInvoiceAllData(invoiceData);
          setPaid(data?.total_paid);
          setDiscount(data?.total_discount);
          setInvoiceDiscountType(data?.discount_type);
          setInvoicePaymentType(data?.payment_type);
          const formattedProducts = formatInvoiceProducts(
            data.invoice_products
          );
          setMainState(formattedProducts);
          setMainInnerState(transformData(data?.invoice_products));
          // Store original invoice products for comparison
          setOriginalInvoiceProducts(data.invoice_products || []);

          // Set defaultValue for the select component
          const defaultValues = Object.keys(formattedProducts).map(
            (key, index) => {
              const product = formattedProducts[key];
              const variant = product.variant[0];
              return {
                value: variant.id,
                label: `${product.productName} [${product.productSku}] - ${
                  variant.name
                } [[${variant.sku || ""}]]`,
                product_id: product.id,
                product_name: product.productName,
                product_sku: product.productSku,
                variant_name: variant.name,
                variant_sku: variant.sku || "",
              };
            }
          );
          setdefaultValue(defaultValues);

          setInvoiceDeliveryType(data?.delivery_type);
          setDeliveryStatus(data?.delivery_status);
          setCustomCharge(Number(data?.delivery_charge));
          setCustomPrice(Number(data?.custom_price) || 0);

          setPaymentAllData({
            card_holder_name: data?.card_holder_name,
            card_number: data?.card_number,
            bank_name: data?.bank_name,
            banK_account_number: data?.banK_account_number,
            banK_account_name: data?.banK_account_name,
            banK_branch_name: data?.banK_branch_name,
            bkash_number: data?.bkash_number,
            bkash_trx_number: data?.bkash_trx_number,
            nagad_number: data?.nagad_number,
            nagad_trx_number: data?.nagad_trx_number,
            reference_id: data?.reference_id,
          });

          setDeliveryService(
            data.delivery_service === 0
              ? { label: "Pathao", value: 0 }
              : { label: "Others", value: 1 }
          );

          setPathaoCity({
            label: data.pathao_city_name || "",
            value: data.pathao_city_id === 0 ? "" : data.pathao_city_id,
          });

          setPathaoZone({
            label: data.pathao_zone_name || "",
            value: data.pathao_zone_id === 0 ? "" : data.pathao_zone_id,
          });

          setPathaoArea({
            label: data.pathao_area_name || "",
            value: data.pathao_area_id === 0 ? "" : data.pathao_area_id,
          });

          setIsLoading(false);
        }
      })
      .catch((err) => {
        const errorData = JSON.parse(err.request.response);
        for (let key in errorData.errors) {
          showToast("error", `${key}: ${errorData.errors[key][0]}`);
        }
        showToast("error", errorData.message);
      });
  }, [id]);

  const postInvoice = useCallback(
    (sendEmail) => {
      const url = `${BASE_URL}api/v1/sales/inventory/invoice/${id}/`;
      const current_user = JSON.parse(localStorage.getItem("userData"));
      const toMobile = `+${toCode}${InvoiceAllData.invoice_to_mobile}`;
      const fromMobile = `+${toCode}${InvoiceAllData.invoice_from_mobile}`;

      // Get deleted invoice products
      const deletedInvoiceProducts = getDeletedInvoiceProducts();

      const dataObj = {
        invoice_date: convertData(InvoiceAllData.invoice_date),
        bill_from: InvoiceAllData.invoice_bill_from,
        bill_to: InvoiceAllData.invoice_bill_to,
        from_mobile: fromMobile,
        to_mobile: toMobile,
        to_email: InvoiceAllData.invoice_to_email,
        from_address: InvoiceAllData.invoice_from_address,
        to_address: Found
          ? FoundCustomer.to_address
          : InvoiceAllData.invoice_to_address,
        delivery_charge:
          invoice_delivery_charge === 2
            ? customCharge
            : delivery_charge[invoice_delivery_charge],
        delivery_charge_type: parseInt(invoice_delivery_charge),
        delivery_status: Delivery_status,
        delivery_type: invoice_delivery_type,
        discount_type: invoice_discount_type,
        total_discount: Discount,
        payment_type: invoice_payment_type,
        ...paymentAllData,
        payment_status: invoice_status,
        total_due: parseInt(getDueAmount()),
        sub_total: isNaN(getSubTotal()) ? 0 : getSubTotal(),
        total_paid: paid,
        total_amount: parseInt(getGrandTotal()),
        custom_price: Number(customPrice) || 0,
        total_vat: 0,
        notes: InvoiceAllData.invoice_notes,
        created_by: current_user.id,
        send_pdf: sendEmail,
        product_list_json: JSON.stringify({
          mainstate: mainState,
          maininnerstate: mainInnerState,
        }),
        invoice_view_json: JSON.stringify(Jdata),
        invoice_products_details: formatInv(mainState),
        deleted_invoice_products: deletedInvoiceProducts,
        to_address2: Found
          ? FoundCustomer.to_address2
          : InvoiceAllData.invoice_to_address2,
        to_country: Found
          ? FoundCustomer.to_country
          : InvoiceAllData.to_country,
        to_district: Found ? FoundCustomer.to_district : watchFields[1]?.label,
        to_division: Found ? FoundCustomer.to_division : watchFields[0]?.label,
        to_zip_code: Found ? FoundCustomer.to_zip_code : watchFields[3],
        to_city: Found ? FoundCustomer.to_city : watchFields[2]?.label,
        exchange_products_json: { data: exArray },
        is_regular: true,
        redex_division: watchFields[0]?.value,
        redex_district: watchFields[1]?.value,
        redex_area: watchFields[2]?.value,
        delivery_service: deliveryService.value,
        pathao_city_name: pathaoCity.label || "",
        pathao_city_id: pathaoCity.value || 0,
        pathao_zone_name: pathaoZone.label || "",
        pathao_zone_id: pathaoZone.value || 0,
        pathao_area_name: pathaoArea.label || "",
        pathao_area_id: pathaoArea.value || 0,
      };

      setInvoiceLoader(true);
      axios
        .patch(url, dataObj)
        .then((res) => {
          if (res.data.status) {
            showToast("success", "Invoice Updated.");
            history.push(path.invoice_list);
          }
        })
        .catch((err) => {
          const errorData = JSON.parse(err.request.response);
          for (let key in errorData.errors) {
            showToast("error", `${key}: ${errorData.errors[key][0]}`);
          }
          showToast("error", errorData.message);
        })
        .finally(() => setInvoiceLoader(false));
    },
    [
      id,
      InvoiceAllData,
      mainState,
      mainInnerState,
      Jdata,
      exArray,
      deliveryService,
      pathaoCity,
      pathaoZone,
      pathaoArea,
      getSubTotal,
      getGrandTotal,
      getDueAmount,
      formatInv,
      getDeletedInvoiceProducts,
      Delivery_status,
      Discount,
      Found,
      FoundCustomer,
      customCharge,
      customPrice,
      delivery_charge,
      history,
      invoice_delivery_charge,
      invoice_delivery_type,
      invoice_discount_type,
      invoice_payment_type,
      invoice_status,
      paid,
      paymentAllData,
      toCode,
      watchFields,
    ]
  );

  // Effects
  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  useEffect(() => {
    getProductList();
  }, [inputQuery, getProductList]);

  useEffect(() => {
    if (selectedDivision.value) {
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivision.value}/`
        )
        .then((response) => {
          setDistrictList(response.data.data.districts || []);
        });
    }
  }, [selectedDivision]);

  useEffect(() => {
    if (selectedDistrict.value) {
      const foundAreas = districtList.find(
        ({ id }) => id === selectedDistrict.value
      )?.areas;
      setUpazillaList(foundAreas || []);
    }
  }, [selectedDistrict, districtList]);

  useEffect(() => {
    if (Object.keys(sInvoice).length !== 0) {
      console.log("sInvoice.to_zip_code", sInvoice.to_zip_code);
      const addressFields = sInvoice.redex_division_details
        ? {
            division: {
              label: sInvoice.redex_division_details.name,
              value: sInvoice.redex_division_details.id,
            },
            district: {
              label: sInvoice.redex_district_details.name,
              value: sInvoice.redex_district_details.id,
            },
            town: {
              label: sInvoice.redex_area_details.name,
              value: sInvoice.redex_area_details.id,
            },
            zip: sInvoice.to_zip_code,
          }
        : {
            division: { label: sInvoice.to_division, value: "" },
            district: { label: sInvoice.to_district, value: "" },
            town: { label: sInvoice.to_city, value: "" },
            zip: sInvoice.to_zip_code,
          };

      reset(addressFields);
      setSelectedDivision(addressFields.division);
      setSelectedDistrict(addressFields.district);
      setSelectedTown(addressFields.town);
    }
  }, [sInvoice, reset]);

  useEffect(() => {
    const output = [];
    for (let i in mainState) {
      for (let j in mainState[i].variantObj) {
        const d = mainState[i].variantObj[j];
        if (d.total !== 0) {
          output.push({
            name: i,
            basePrice: mainState[i].price,
            thumb: mainState[i].thumb,
            discount: mainState[i].discount,
            price: d.price,
            quantity: d.quantity,
            id: d.id,
            total: d.total,
            variant: d.name,
          });
        }
      }
    }
    setJData(output);
  }, [mainState]);

  useEffect(() => {
    const data = exchanged
      .filter((item) => deleted.includes(item.product_name))
      .map((item) => item.id);
    setExarray(data);
  }, [mainState, deleted, exchanged]);

  // Handlers
  const handleDivisionChange = (division) => {
    if (division?.value) {
      setSelectedDistrict({ label: "", value: "" });
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setDistrictList([]);
      setSelectLoading(true);
      setCustomCharge(0);
      setSelectedDivision(division);
      setValue("division", division);
    }
  };

  const handleDistrictChange = (district) => {
    if (district?.value) {
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setUpazillaList([]);
      setSelectLoading(false);
      setCustomCharge(0);
      setSelectedDistrict(district);
      setValue("district", district);
    }
  };

  const handleTownChange = (town) => {
    if (town?.value) {
      setValue("zip", "");
      setSelectedTown(town);
      setValue("town", town);
      const foundDeliveryCharge = upazillaList.find(
        ({ id }) => id === town.value
      )?.delivery_charge;
      if (foundDeliveryCharge) {
        setCustomCharge(Number(foundDeliveryCharge));
        setInvoiceDeliveryCharge(2);
      }
    }
  };

  const handleMultiInputChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      const option = actionMeta.option;
      const productName = option.product_name;
      const variantName = option.variant_name;
      const productSku =
        option.product_sku || option.productSKU || option.product_sku_code;
      const variantSku = option.variant_sku;
      const uniqueKey =
        productSku && variantSku
          ? `${productSku}_${variantName}_${variantSku}`
          : `${productName}_${variantName}`;

      // Check if this specific variant already exists
      if (mainState[uniqueKey]) {
        console.log("Variant already exists, skipping");
        return;
      }

      // Create new variant entry with unique key
      const newVariant = {
        id: option.value,
        name: variantName,
        price: option.price,
        stock: option.stock,
        product: option.product_id,
        quantity: -1,
        total: 0,
      };

      const variantsObj = {
        [variantName]: newVariant,
      };

      setMainState((prevMainState) => ({
        ...prevMainState,
        [uniqueKey]: {
          id: option.product_id,
          variant: [newVariant],
          variantObj: variantsObj,
          price: parseInt(option.main_price),
          stock: parseInt(option.stock),
          thumb: option.thumb,
          discount: parseInt(option.main_discount),
          productName: productName,
          productSku: productSku,
        },
      }));

      // Add to defaultValue
      setdefaultValue((prevDefaultValue) => {
        return [
          ...prevDefaultValue,
          {
            value: option.value,
            label: option.label,
          },
        ];
      });
    }

    if (actionMeta.action === "remove-value") {
      const removedOption = actionMeta.removedValue;

      if (removedOption) {
        const productSku =
          removedOption.product_sku ||
          removedOption.productSKU ||
          removedOption.product_sku_code;
        const variantSku = removedOption.variant_sku;
        const variantName = removedOption.variant_name;
        let uniqueKey;

        if (productSku && variantSku && variantName) {
          uniqueKey = `${productSku}_${variantName}_${variantSku}`;
        } else if (removedOption.label) {
          // Parse from label format
          const label = removedOption.label;
          const parts = label.split(" - ");
          if (parts.length >= 2) {
            const left = parts[0];
            const right = parts[1];
            const productSkuMatch = left.match(/\[(.*?)\]$/);
            const parsedProductSku = productSkuMatch
              ? productSkuMatch[1]
              : undefined;
            const parsedVariantName = right.split(" [[")[0];
            const variantSkuMatch = right.match(/\[\[(.*?)\]\]/);
            const parsedVariantSku = variantSkuMatch
              ? variantSkuMatch[1]
              : undefined;

            if (parsedProductSku && parsedVariantName && parsedVariantSku) {
              uniqueKey = `${parsedProductSku}_${parsedVariantName}_${parsedVariantSku}`;
            } else {
              uniqueKey = `${parts[0]}_${parsedVariantName}`;
            }
          }
        }

        if (uniqueKey && mainState[uniqueKey]) {
          setDeleted((prev) => [...prev, uniqueKey]);
          setMainState((prev) => {
            const newState = { ...prev };
            delete newState[uniqueKey];
            return newState;
          });
        }
      }

      setdefaultValue((prevDefaultValue) =>
        prevDefaultValue.filter(
          (value) =>
            value.label !== actionMeta.removedValue.label &&
            value.value !== actionMeta.removedValue.value
        )
      );
    }
  };

  const handlePrint = useReactToPrint({
    content: () => print.current,
    documentTitle: "emp-data",
    bodyClass: "dis",
  });

  const handlePrint2 = () => {
    if (
      InvoiceAllData.invoice_from_email ||
      InvoiceAllData.invoice_to_email ||
      InvoiceAllData.invoice_bill_to ||
      InvoiceAllData.invoice_bill_form
    ) {
      handlePrint();
    } else {
      swal("error");
    }
  };

  const ValidateData = (sendEmail) => {
    const bd = /^[1][0-9]{9}$/;
    const errors = [];

    if (!InvoiceAllData.invoice_date) errors.push("Issue Date can't be empty");
    if (!bd.test(InvoiceAllData.invoice_from_mobile?.replace("+880", ""))) {
      errors.push("From Mobile: Please Enter Valid phone number");
    }
    if (!bd.test(InvoiceAllData.invoice_to_mobile?.replace("+880", ""))) {
      errors.push("To Mobile: Please Enter Valid phone number");
    }
    if (!Found && !InvoiceAllData.invoice_bill_from)
      errors.push("Bill from can't be empty");
    if (!Found && !InvoiceAllData.invoice_bill_to)
      errors.push("Bill to can't be empty");
    if (!InvoiceAllData.invoice_from_email)
      errors.push("From email can't be empty");
    if (!validateEmail(InvoiceAllData.invoice_from_email))
      errors.push("From email not valid");
    if (
      InvoiceAllData.invoice_to_email &&
      !validateEmail(InvoiceAllData.invoice_to_email)
    ) {
      errors.push("To email not valid");
    }
    if (!Found && !InvoiceAllData.invoice_to_address)
      errors.push("To address can't be empty");
    if (Object.keys(mainState).length <= 0)
      errors.push("Product Details is empty");

    if (deliveryService.value === 1) {
      if (!watchFields[0]?.label && !FoundCustomer.to_division)
        errors.push("Division is empty");
      if (!watchFields[1]?.label && !FoundCustomer.to_district)
        errors.push("District is empty");
      if (!watchFields[2]?.label && !FoundCustomer.to_city)
        errors.push("City is empty");
    }

    if (deliveryService.value === 0) {
      if (!pathaoCity?.label) errors.push("City is empty");
      if (!pathaoZone?.label) errors.push("Zone is empty");
      if (!pathaoArea?.label) errors.push("Area is empty");
    }

    if (errors.length > 0) {
      errors.forEach((error) => showToast("error", error));
      return false;
    }

    postInvoice(sendEmail);
    return true;
  };

  const SaveAndSendEmail = () => ValidateData(true);

  const inputProduct = (inputValue) => {
    setInputQuery(inputValue);
  };

  const toPhoneHandle = (e) => {
    let number = e.target.value;
    handleInputs(e, setInvoiceAllData);
    if (number.length === 10) {
      const url = `${BASE_URL}/api/v1/inventory/inventory/customer/?limit=20&offset=0&filter=&search=${number}`;
      axios.get(url).then((res) => {
        if (res.data.data.results.length !== 0) {
          setPathaoCity({
            label: res.data.data.results[0].pathao_city_name
              ? res.data.data.results[0].pathao_city_name
              : "",
            value:
              res.data.data.results[0].pathao_city_id === 0
                ? ""
                : res.data.data.results[0].pathao_city_id,
          });

          setPathaoZone({
            label: res.data?.data?.results[0]?.pathao_zone_name,
            value:
              res.data?.data?.results[0]?.pathao_zone_id === 0
                ? ""
                : res.data?.data?.results[0]?.pathao_zone_id,
          });

          setPathaoArea({
            label: res.data?.data?.results[0]?.pathao_area_name
              ? res.data?.data?.results[0]?.pathao_area_name
              : "",
            value:
              res.data?.data?.results[0]?.pathao_area_id === 0
                ? ""
                : res.data?.data?.results[0]?.pathao_area_id,
          });
          setFound(true);
          setFoundCustomer(res.data.data.results[0]);
          showToast("success", "Found Customer");
        } else {
          setFound(false);
        }
      });
    }
  };

  const handleQuantity = (e, curr, variant) => {
    const uniqueKey = curr;
    const variantName = variant.name;

    if (e.target.value < 0) {
      setPs(0);
    } else {
      setPs(e.target.value);
    }

    setMainState((prevInputs) => {
      const copiedObjects = Object.assign({}, mainState);

      if (parseInt(e.target.value) < 0) {
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = 0;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] = 0;
      } else {
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = parseInt(
          e.target.value
        );
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] =
          parseInt(e.target.value);
      }

      let checkDiscountPrice =
        parseInt(copiedObjects[uniqueKey]["discount"]) === 0
          ? parseInt(copiedObjects[uniqueKey]["price"])
          : parseInt(copiedObjects[uniqueKey]["discount"]);

      const baseAndVariant = parseInt(variant.price) + checkDiscountPrice;

      copiedObjects[uniqueKey]["variant"][0]["total"] =
        parseInt(copiedObjects[uniqueKey]["variant"][0]["quantity"]) *
        baseAndVariant;

      const baseAndVariantObj =
        parseInt(copiedObjects[uniqueKey]["variantObj"][variantName]["price"]) +
        checkDiscountPrice;

      copiedObjects[uniqueKey]["variantObj"][variantName]["total"] =
        parseInt(
          copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"]
        ) * baseAndVariantObj;

      return copiedObjects;
    });
  };

  console.log(defaultValue, "defaultValue");

  // Component rendering
  if (!has_permissions(can_add_invoice)) {
    return <Permission />;
  }

  if (isLoading) return <Loader />;

  return (
    <div className="categorey-parent">
      {/* Scanner Component */}
      <Scanner2 setScanCode={() => {}} />

      {/* Product Details Component */}
      <ProductDetails
        mainState={mainState}
        setMainState={setMainState}
        mainInnerState={mainInnerState}
        setMainInnerState={setMainInnerState}
        selectedVariants={selectedVariants}
        setSelectedVariants={setSelectedVariants}
        ProductsList={ProductsList}
        setProductsList={setProductsList}
        defaultValue={defaultValue}
        setdefaultValue={setdefaultValue}
        inputQuery={inputQuery}
        setInputQuery={setInputQuery}
        handleMultiInputChange={handleMultiInputChange}
        inputProduct={inputProduct}
        handleQuantity={handleQuantity}
        getSubTotal={getSubTotal}
        getDeliveryCharge={getDeliveryCharge}
        getGrandTotal={getGrandTotal}
        getDueAmount={getDueAmount}
        customCharge={customCharge}
        setCustomCharge={setCustomCharge}
        customPrice={customPrice}
        setCustomPrice={setCustomPrice}
        Discount={Discount}
        setDiscount={setDiscount}
        paid={paid}
        setpaid={setPaid}
        invoice_discount_type={invoice_discount_type}
        invoice_delivery_charge={invoice_delivery_charge}
        setinvoice_delivery_charge={setInvoiceDeliveryCharge}
        delivery_charge={delivery_charge}
        isLoading={isLoading}
        pS={pS}
        setPs={setPs}
      />

      {/* Invoice Details Component */}
      <InvoiceDetails
        InvoiceAllData={InvoiceAllData}
        SetInvoiceAllData={setInvoiceAllData}
        Found={Found}
        FoundCustomer={FoundCustomer}
        setFoundCustomer={setFoundCustomer}
        deliveryService={deliveryService}
        setDeliveryService={setDeliveryService}
        pathaoCity={pathaoCity}
        setPathaoCity={setPathaoCity}
        pathaoZone={pathaoZone}
        setPathaoZone={setPathaoZone}
        pathaoArea={pathaoArea}
        setPathaoArea={setPathaoArea}
        selectedDivision={selectedDivision}
        setSelectedDivision={setSelectedDivision}
        selectedDistrict={selectedDistrict}
        setSelectedDistrict={setSelectedDistrict}
        selectedTown={selectedTown}
        setSelectedTown={setSelectedTown}
        districtList={districtList}
        setDistrictList={setDistrictList}
        upazillaList={upazillaList}
        setUpazillaList={setUpazillaList}
        selectLoading={selectLoading}
        setSelectLoading={setSelectLoading}
        customCharge={customCharge}
        setCustomCharge={setCustomCharge}
        watchFields={watchFields}
        setValue={setValue}
        control={control}
        register={register}
        handleDivisionChange={handleDivisionChange}
        handleDistrictChange={handleDistrictChange}
        handleTownChange={handleTownChange}
        toPhoneHandle={toPhoneHandle}
        fromCode={fromCode}
        setFromCode={setFromCode}
        toCode={toCode}
        setToCode={setToCode}
        invoice_delivery_type={invoice_delivery_type}
        setinvoice_delivery_type={setInvoiceDeliveryType}
        invoice_discount_type={invoice_discount_type}
        setinvoice_discount_type={setInvoiceDiscountType}
        invoice_delivery_charge={invoice_delivery_charge}
        setinvoice_delivery_charge={setInvoiceDeliveryCharge}
        delivery_charge={delivery_charge}
        paymentType={paymentType}
        invoice_payment_type={invoice_payment_type}
        setinvoice_payment_type={setInvoicePaymentType}
        paymentAllData={paymentAllData}
        setPaymentAllData={setPaymentAllData}
        clearPaymentALlData={() =>
          setPaymentAllData({
            card_holder_name: "",
            card_number: "",
            bank_name: "",
            banK_account_number: "",
            banK_account_name: "",
            banK_branch_name: "",
            bkash_number: "",
            bkash_trx_number: "",
            nagad_number: "",
            nagad_trx_number: "",
            reference_id: "",
          })
        }
        handleInputs={handleInputs}
      />

      {/* Payment Status Component */}
      <PaymentStatus
        invoice_payment_type={invoice_payment_type}
        paymentAllData={paymentAllData}
        setPaymentAllData={setPaymentAllData}
        handleInputs={handleInputs}
        invoice_status={invoice_status}
        setinvoice_status={setInvoiceStatus}
        Delivery_status={Delivery_status}
        setDelivey_status={setDeliveryStatus}
        InvoiceAllData={InvoiceAllData}
        SetInvoiceAllData={setInvoiceAllData}
        invoice_choices1={invoice_choices}
        delivery_choices={delivery_choices}
      />

      {/* Action Buttons */}
      <div
        className="floating-bar padding-btn-head mb-4 d-flex justify-content-end bg-white cat-child"
        style={{ border: "0.5px solid #E0E0E0" }}
      >
        <div style={{ marginLeft: "-10px" }}>
          <button
            className="btn rounded border align-items-center d-none me-2 mt-2"
            disabled={!InvoiceAllData}
            onClick={handlePrint2}
          >
            <DoIcon className="doc" /> Preview PDF
          </button>

          {invoiceLoader ? (
            <button disabled className="btn rounded border me-2 mt-2">
              <MoonLoader color="black" size={10} /> Updating...
            </button>
          ) : (
            <button
              onClick={() => ValidateData(false)}
              className="btn rounded border me-2 mt-2"
            >
              Update Invoice
            </button>
          )}

          {InvoiceAllData.invoice_to_email &&
            !Found &&
            validateEmail(InvoiceAllData.invoice_to_email) && (
              <button
                onClick={SaveAndSendEmail}
                className="btn rounded border text-white mt-2"
                style={{ background: "black" }}
              >
                Update & Send PDF
              </button>
            )}

          <button
            className="btn rounded border me-2 ms-2 mt-2"
            onClick={() => history.push(path.invoice_list)}
          >
            Cancel
          </button>

          {/* Hidden Preview Component */}
          <div className="d-none">
            <PreviewCreate
              print={print}
              status={invoice_payment_type}
              Found={Found}
              InvoiceAllData={InvoiceAllData}
              FoundCustomer={FoundCustomer}
              mainState={mainState}
              invStatus={invoice_status}
              Jdata={Jdata}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VariantEditInvoice;
